"use client"

import { PlayCircle } from "lucide-react"
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card"
import CognitiveAssessmentDialog from "@/views/cognitive/CognitiveAssessmentDialog"

import testyZawodoweImage from '@/assets/testyZawodowe.png'

interface TestCardProps {
  id: string
  title: string
  image: string | undefined
  goal: string
  limitations: string
  procedure: string
  recommendations: string
  onStartTest: (id: string) => void
}

export function TestCard({
  id,
  title,
  image,
  goal,
  limitations,
  procedure,
  recommendations,
  onStartTest,
}: TestCardProps) {
  return (
    <Card className="pt-0 overflow-hidden rounded-none border-gray-200 transition-all duration-300 hover:shadow-lg cursor-pointer group flex flex-col h-full">
      <div className="relative h-48 w-full overflow-hidden" onClick={() => onStartTest(id)}>
        <img
          src={image ?? testyZawodoweImage}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <PlayCircle className="h-16 w-16 text-white" />
        </div>
      </div>

      <CardHeader className="pb-2">
        <h3 className="text-xl font-bold">{title}</h3>
      </CardHeader>

      <CardContent className="flex-grow">
        <p className="text-sm text-muted-foreground text-gray-500 mb-4">{goal}</p>
      </CardContent>

      <CardFooter className="mt-auto flex flex-col gap-4">
        <CognitiveAssessmentDialog 
          title={title}
          goal={goal}
          limitations={limitations}
          procedure={procedure}
          recommendations={recommendations}
          isPreview={true}
        />
        <CognitiveAssessmentDialog 
          title={title}
          goal={goal}
          limitations={limitations}
          procedure={procedure}
          recommendations={recommendations}
          onAccept={() => onStartTest(id)}
        />
      </CardFooter>
    </Card>
  )
}
 